<!-- begin #header -->
<div id="header" class="header navbar-default top-menu">
  <!-- begin navbar-header -->
  <div class="navbar-header">
    <a class="navbar-brand" href="#">
      <img class="imagen_logo" src="images/logo/logo_zurich.png" alt="Zurich Logo" />
    </a>
  </div>
  <!-- end navbar-header -->
</div>
<!-- end #header -->
